export default __webpack_public_path__ + "static/media/cta.1ccf172b.png";